export default function FooterPublic() {
  return (
    <footer className="w-full h-12 bg-segments-dark ">
      <div className="flex items-center justify-end w-full h-full px-5 mx-auto max-w-screen-segments-1440px lg:pr-40">
        <p className="font-bold text-white text-segments-13px">
          Made with <span className="text-red-500">&hearts;</span>{' '}
          <a href="https://tresl.co">Tresl.co</a>
        </p>
      </div>
    </footer>
  );
}
